import type { ActiveDayHistory } from '@engage/overview-ui/models';
import type { Overview } from '../../models/Overview';

export const OVERVIEW_NAMESPACE = 'overview';

export type State = Record<
  string,
  Overview & {
    activeDayHistory: ActiveDayHistory;
    activeDayHistoryNonPartner3p: ActiveDayHistory;
  }
>;

export type OverviewSelectorState = {
  [OVERVIEW_NAMESPACE]: State;
};
